import { ShowEventType } from '@api';
import {
  ArtistAnchor,
  CompanyAnchor,
  PersonAnchor,
  TourAnchor,
  VenueAnchor,
} from '@common';
import { faCalendar, faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const TRANS_KEY = 'TOURING_SCHEDULE';

type ShowHoverCardPropsType = {
  show: ShowEventType;
};

export const ShowHoverCard: React.FC<ShowHoverCardPropsType> = ({ show }) => {
  const { t } = useTranslation('dashboard');

  const artists = [
    show.show.artist,
    show.show.coHeadliner1,
    show.show.coHeadliner2,
  ].filter((artist) => artist !== null);

  return (
    <Stack align="center" gap={16}>
      <Stack align="center" gap={1}>
        <Text fw={700}>
          {artists.map((artist, index) => (
            <>
              <ArtistAnchor key={artist.id} artist={artist} />
              {index < artists.length - 1 && ' & '}
            </>
          ))}
          {' | '}
          <TourAnchor tour={show.show.tour} />
        </Text>
        <Group gap={2}>
          <FontAwesomeIcon icon={faLocationDot} size="sm" />
          <VenueAnchor venue={show.show.venue} />
        </Group>
      </Stack>

      <Stack align="center" gap={1}>
        <Group gap={2}>
          <Text>{t(`${TRANS_KEY}.TOUR_PROD`)}</Text>
          {show.tourProd ? (
            <PersonAnchor person={show.tourProd} />
          ) : (
            <Text c="grey">{t(`${TRANS_KEY}.NOT_FILLED`)}</Text>
          )}
        </Group>

        <Group gap={2}>
          <Text>{t(`${TRANS_KEY}.TOUR_REP`)}</Text>
          {show.tourRep ? (
            <PersonAnchor person={show.tourRep} />
          ) : (
            <Text c="grey">{t(`${TRANS_KEY}.NOT_FILLED`)}</Text>
          )}
        </Group>

        <Group gap={2}>
          <Text>{t(`${TRANS_KEY}.TOUR_ACC`)}</Text>
          {show.tourAcc ? (
            <PersonAnchor person={show.tourAcc} />
          ) : (
            <Text c="grey">{t(`${TRANS_KEY}.NOT_FILLED`)}</Text>
          )}
        </Group>

        <Group gap={2}>
          <Text>{t(`${TRANS_KEY}.TOUR_SEC`)}</Text>
          {show.tourSec ? (
            <PersonAnchor person={show.tourSec} />
          ) : (
            <Text c="grey">{t(`${TRANS_KEY}.NOT_FILLED`)}</Text>
          )}
        </Group>

        <Group gap={2}>
          <Text>{t(`${TRANS_KEY}.TOUR_VIP`)}</Text>
          {show.tourVip ? (
            <PersonAnchor person={show.tourVip} />
          ) : (
            <Text c="grey">{t(`${TRANS_KEY}.NOT_FILLED`)}</Text>
          )}
        </Group>

        <Group gap={2}>
          {show.coPro ? (
            <>
              <Text>{t(`${TRANS_KEY}.CO_PRO`)}</Text>
              <CompanyAnchor company={show.coPro} />
            </>
          ) : null}
        </Group>
      </Stack>

      <Group gap={2}>
        <FontAwesomeIcon icon={faCalendar} size="sm" />
        <Text>{dayjs(show.show.showDate).format('DD.MM.YYYY')}</Text>
      </Group>
    </Stack>
  );
};
